<template>
    <v-layout justify-center>
        <v-responsive max-width="1280px" width="100%" height="100%">
            <v-row class="mt-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">포트폴리오 목록</v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col>
            </v-row>

            <v-expand-transition>
                <v-card v-show="showSearch" class="elevation-1 mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                    <v-card-text class="pt-4 pb-0">
                        <v-row>
                            <v-col cols="auto" class="subtitle-2">카테고리</v-col>
                            <v-col class="ma-0 py-0">
                                <portfolio-category-select dense hide-details :categories="categories" @input="(category) => (filter._category = category._id)"></portfolio-category-select>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="pt-0">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded text @click="search"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>

            <v-data-table :headers="portfoliosHeaders.filter((header) => payload.scope.find((scope) => header.scope.includes(scope)))" :items="portfolios" disable-sort disable-pagination hide-default-footer class="elevation-1 mt-4">
                <template v-slot:[`item.subject`]="{ item }">
                    <v-row align="center">
                        <v-col cols="auto">
                            <v-img v-if="item.thumb" :src="item.thumb" max-width="56" max-height="56"></v-img>
                            <v-responsive v-else width="56" height="56">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                        <v-col class="text-start">
                            {{ item.subject }}
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.construction.acreage`]="{ item }">
                    <span>{{ (item.construction.acreage || 0).format() }} 평</span>
                </template>
                <template v-slot:[`item.construction.supplyPrice`]="{ item }">
                    <span>{{ (item.construction.supplyPrice || 0).format() }} 만원</span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon small @click="remove(item)" class="ml-2">mdi-delete</v-icon>
                </template>

                <template v-slot:[`item.main`]="{ item }">
                    <v-row align="center" justify="center" v-if="!checkIsPartial(item)">
                        <v-col cols="auto" class="py-0">
                            <v-switch color="green" dense hide-details class="ma-0 pa-0" @change="save(item)" v-model="item.main"></v-switch>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" class="mt-4 mb-12" @input="search()"></v-pagination>

            <v-btn v-if="payload.scope.includes('interior')" bottom color="accent" fab fixed right @click="create">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

import PortfolioCategorySelect from "@/components/console/portfolio/category/portfolio-category-select.vue";
export default {
    components: {
        PortfolioCategorySelect,
    },
    async mounted() {
        await this.search();
    },
    data() {
        return {
            showSearch: true,

            filter: {
                _category: null,
            },

            categories: [],

            page: 1,
            pageCount: 0,
            limit: 10,

            portfolios: [],
            portfoliosHeaders: [
                {
                    text: "제목",
                    align: "center",
                    width: 500,
                    value: "subject",
                    scope: ["console", "interior"],
                },
                {
                    text: "업체명",
                    align: "center",
                    width: 140,
                    value: "user.meta.companyName",
                    scope: ["console"],
                },
                {
                    text: "시공지역",
                    align: "center",
                    width: 240,
                    value: "construction.address",
                    scope: ["console", "interior"],
                },
                {
                    text: "시공범위",
                    align: "center",
                    width: 100,
                    value: "construction.scope",
                    scope: ["console", "interior"],
                },
                {
                    text: "시공면적",
                    align: "center",
                    width: 100,
                    value: "construction.acreage",
                    scope: ["console", "interior"],
                },
                {
                    text: "공급가격",
                    align: "center",
                    width: 100,
                    value: "construction.supplyPrice",
                    scope: ["console", "interior"],
                },
                {
                    text: "Actions",
                    align: "center",
                    width: 100,
                    value: "actions",
                    scope: ["interior"],
                },
                {
                    text: "메인노출",
                    align: "center",
                    width: 100,
                    value: "main",
                    scope: ["console"],
                },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        selectCategory(category) {
            this._category = category._id;
        },

        async init() {
            try {
                var { categories } = await api.console.portfolios.categories.getCategories();
                this.categories = categories;

                await this.search(false);
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },

        async search(routable = true) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, this.query, { page: this.page }),
                    });
                }

                var { summary, portfolios } = await api.console.portfolios.getPortfolios({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.portfolios = portfolios;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        create() {
            this.$router.push(`/console/portfolio/create`);
        },

        edit(portfolio) {
            this.$router.push(`/console/portfolio/${portfolio._id}`);
        },

        async save(portfolio) {
            try {
                await api.console.portfolios.putPortfolio(portfolio);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async remove(portfolio) {
            if (confirm("삭제하시겠습니까?")) {
                await api.console.portfolios.deletePortfolio(portfolio);
                await this.search(false);
            }
        },
        checkIsPartial({ _category }) {
            const partial = this.categories.find(({ name }) => name == "부분시공");
            if (_category == partial._id) return true;
            if (partial._children.includes(_category)) return true;
            console.log("isFalse");
            return false;
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload;
        },
    },
};
</script>
